import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import { initializeApp } from "firebase/app";
import { collection, getDocs, getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB-GjLjhDtTCyXce48RTIzLsfWqD63o5Rg",
  authDomain: "recipes-b0caf.firebaseapp.com",
  projectId: "recipes-b0caf",
  storageBucket: "recipes-b0caf.appspot.com",
  messagingSenderId: "925632164527",
  appId: "1:925632164527:web:3bebb08879cb726fb41a5a",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export const firebaseApi = createApi({
  reducerPath: "firebaseApi",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["Recipe"],
  endpoints: (builder) => ({
    recipes: builder.query<Recipe[], void>({
      async queryFn() {
        try {
          const recipeRef = collection(db, "recipe_videos");
          const querySnaphot = await getDocs(recipeRef);
          const recipes: Recipe[] = [];
          querySnaphot?.forEach((doc) => {
            recipes.push({ id: doc.id, ...doc.data() } as Recipe);
          });
          return { data: recipes };
        } catch (error) {
          return { error };
        }
      },
      providesTags: ["Recipe"],
    }),
  }),
});

export const { useRecipesQuery } = firebaseApi;

export type Recipe = {
  id: string;
  bin_id: string;
  sku_image: string;
  sku_name: string;
  video_url: string;
  qr_url: string;
  sku_id: string;
};
